import { ArrowsAltOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  ActionButtons,
  ProgressElement,
} from 'horizon/components/GlobalProgressIndicator/GenericProgress/GenericProgressToast.style';

import { FileUploadProgressSummary } from '../FileUploadProgressSummary';

export function FileUploadToast({ showModal }: { showModal: () => void }) {
  const { t } = useTranslation();
  return (
    <ProgressElement>
      <ActionButtons>
        <Button
          icon={<ArrowsAltOutlined />}
          size="small"
          title={t('fileUpload.viewFileList', 'View file list')}
          onClick={showModal}
        />
      </ActionButtons>
      <span>{t('fileUpload.filesUploaded', 'Files uploaded:')}</span>
      <FileUploadProgressSummary />
    </ProgressElement>
  );
}
